import crud from "./_crud";
 
 const actions = crud('unit_axle_template', 'el tipo de unidad', 'los tipos de unidades')

export default actions